import React, {useEffect} from "react";
import { Row, Col } from "react-bootstrap";
import GeneralGridItem from "../GeneralGridItem";
import {  getAllCategoryWithPagination2 } from "../../services/CategoryService";
import { Link } from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux'
import { updateCategoriesWidget } from '../../redux/homePageSlice'

function CategoryWidget() {

    const  items  = useSelector((state) => state.homepage.categoriesWidget);
    const  languageId  = 1;
  
  const dispatch = useDispatch()

  console.log("cate")

  useEffect(() => {
    getAllCategoryWithPagination2( languageId, 1, 4).then(
        (res) => {
          console.log(res)
          dispatch(updateCategoriesWidget(res)) ;
          
        },
        (failure) => {
          console.error(failure); 
        }
      );
  }, [languageId, dispatch]);


  return (
    <section className="brand-sec-margin">
      <div className="container">
        <Row className="pb-2">
          <Col md={6} sm={6} xs={6} className="d-flex flex-column">
            <span className="header-1 home-sec">Categories</span>
            <p className="sub-heading">Shop selected Categories</p>
          </Col>
          <Col md={6} sm={6} xs={6} className="d-flex align-items-center justify-content-end">
            <Link to={`/categories`} className="big-Link">
              SEE ALL Categories
            </Link>
          </Col>
        </Row>
        <Row className="mobile-grid">
          {items.map((item) => {
            return <GeneralGridItem imgUrl={ item.imageURL} key={item.id} totalProducts={item.totalProducts}  name= {item.name} id={item.id}  type="category" />;
          })}
        </Row>
      </div>
    </section>
  );
}

export default CategoryWidget;
